import { render, staticRenderFns } from "./CaZigu.vue?vue&type=template&id=7256e08b&scoped=true&"
import script from "./CaZigu.vue?vue&type=script&lang=js&"
export * from "./CaZigu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7256e08b",
  null
  
)

export default component.exports